import React, { Component, ReactElement } from 'react'
import { Route } from '../Annotation/Route'
import { ChildRouteID, RouteID } from '../Components/Molecules/Header/Types/Types'
import { RouteGuard } from '../Guards/RouteGuard'
import { CXScore } from '../Components/Organisms/CXScore/CXScore'

/**
 * /cxScore and its children are handled by this page component.
 */
@Route(RouteID.CXSCORE, {
    children: [ChildRouteID.CXSCORE_OVERVIEW, ChildRouteID.CXSCORE_CX_SCORE, ChildRouteID.CXSCORE_CALLS]
})
export class CXScorePage extends Component {
    render(): ReactElement {
        return (
            <RouteGuard route={RouteID.CXSCORE}>
                <CXScore />
            </RouteGuard>
        )
    }
}
